interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
}

const SITE_URL = "https://mvlock.cn";

export default function Seo({ title, description, keywords, path }: SeoProps) {
  const url = `${SITE_URL}${path}`;
  const lastModified = new Date().toISOString().slice(0, 10);

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="last-modified" content={lastModified} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="独家吃瓜" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </>
  );
}

export function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}